import React, { useState, useEffect, useRef } from "react";
import ApiCustom from "../../utils/ApiCustom";
import { convertToSlug } from "../../utils/helps";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const UserPDFModal = ({ isOpen, onClose, company }) => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const pdfRef = useRef();

  useEffect(() => {
    if (isOpen) {
      setData(
        company?.users.find((e) => e.CompaniesHasUsers.isUserRepresentOfCompany)
      );
    }
  }, [isOpen]);

  const handleDownloadPDF = async () => {
    setIsLoading(true);
    const elements = pdfRef.current.children;
    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      const canvas = await html2canvas(element, { useCORS: true, scale: 2 });
      const dataURL = canvas.toDataURL("image/png");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(dataURL, "PNG", 0, 0, imgWidth, imgHeight);
    }

    pdf.save("chao_mung.pdf");
    setIsLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-base-100 p-0 lg:p-6 rounded-lg w-5/6 lg:w-3/4 max-h-[90vh] overflow-y-auto">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-end mb-10">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 btn btn-outline rounded btn-sm  mt-3"
            >
              X
            </button>
          </div>

          <div className="space-y-5" ref={pdfRef}>
            <div className="relative w-full max-w-2xl mx-auto">
              <img
                src="/template_background_bccu.png"
                alt="Background"
                className="w-full h-auto object-cover"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-center text-white text-base md:text-xl">
                <div className="px-4 w-full py-24 lg:py-56 flex flex-col justify-between">
                  <div className="grid grid-cols-[100px,1fr] md:grid-cols-[230px,1fr] items-center gap-4 md:gap-6 w-full">
                    {/* Avatar */}
                    <div className="w-24 h-24 md:w-52 md:h-52 rounded-full border-4 border-yellow-500 overflow-hidden">
                      <img
                        src={
                          data?.userAvatar ||
                          `https://ui-avatars.com/api/?name=${data?.userFullName}&size=200&background=random&color=fff&bold=true`
                        }
                        alt="Profile"
                        className="w-full h-full object-cover"
                        loading="eager"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `https://ui-avatars.com/api/?name=${data?.userFullName}&size=200&background=random&color=fff&bold=true`;
                        }}
                      />
                    </div>

                    {/* Thông tin */}
                    <div className="flex flex-col justify-between h-full pt-2 text-[10px] md:text-lg leading-[1.4]">
                      <div className="font-bold uppercase">
                        <div className="pb-2 md:pb-3">
                          {data?.company?.companyName}
                        </div>
                        <div className="text-yellow-500">
                          {data?.userFullName}
                        </div>
                        <div>{data?.position}</div>
                      </div>
                      <div>
                        <div>Điện thoại: {data?.userPhone}</div>
                        <div>Email: {data?.userEmail}</div>
                        <div>Nơi sinh: {data?.userAddress}</div>
                      </div>
                    </div>
                  </div>

                  {/* Thông tin doanh nghiệp */}
                  <div className="pl-2 md:pl-4 pt-4 w-full space-y-1 md:space-y-2 text-[10px] md:text-lg leading-[1.4]">
                    <div>
                      <div className="font-bold">Lĩnh vực hoạt động:</div>
                      <ul className="list-disc pl-5 md:pl-10 space-y-1">
                        {company?.businessFields?.map((field) => (
                          <li>{field.name}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <div className="font-bold">Thông tin doanh nghiệp:</div>
                      <ul className="space-y-1">
                        <li>Điện thoại: {company?.userPhone}</li>
                        <li>Email: {company?.userEmail}</li>
                        <li>Địa chỉ: {company?.businessAddress}</li>
                        <li>
                          Website: {company?.websiteOrHotline}
                          Hotline: {company?.hotline}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative w-full max-w-2xl mx-auto">
              <img
                src="/template_background_bccu.png"
                alt="Background"
                className="w-full h-auto object-cover"
              />

              <div className="absolute top-0 left-0 w-full h-full flex items-center text-white text-base md:text-xl">
                <div className="px-4 w-full h-full py-24 lg:py-56 flex flex-col justify-between">
                  <div className="flex flex-col items-center uppercase font-bold lg:space-y-2 text-[12px] leading-[1.5] lg:text-[20px]">
                    <div>Chào mừng</div>
                    <div>{company?.companyName}</div>
                  </div>
                  <div className="">
                    <div className="grid grid-cols-[100px,1fr] md:grid-cols-[230px,1fr] items-center gap-4 md:gap-6 w-full">
                      {/* Avatar */}
                      <div className="w-24 h-24 md:w-52 md:h-52 rounded-full border-4 border-yellow-500 overflow-hidden">
                        <img
                          src={
                            data?.userAvatar ||
                            `https://ui-avatars.com/api/?name=${data?.userFullName}&size=200&background=random&color=fff&bold=true`
                          }
                          alt="Profile"
                          className="w-full h-full object-cover"
                          loading="eager"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://ui-avatars.com/api/?name=${data?.userFullName}&size=200&background=random&color=fff&bold=true`;
                          }}
                        />
                      </div>

                      {/* Thông tin */}
                      <div className="flex flex-col justify-center h-full pt-2 text-xs md:text-lg">
                        <div>
                          <div className="font-bold">Sản phẩm / dịch vụ:</div>
                          <ul className="list-disc pl-5 md:pl-10 space-y-1">
                            {company?.businessFields?.map((field) => (
                              <li>{field.name}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Thông tin doanh nghiệp */}
                    <div className="pl-2 md:pl-4 pt-4 w-full space-y-1 md:space-y-2 text-xs md:text-lg">
                      <div className="font-bold uppercase">
                        <div className="text-yellow-500">
                          {data?.userFullName}
                        </div>
                        <div>{data?.CompaniesHasUsers?.userPosition}</div>
                      </div>
                    </div>
                  </div>
                  <div className="uppercase font-bold flex justify-center text-[12px] lg:text-[20px]">
                    Là thành viên chính thức
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end space-x-4 mt-10">
            <button
              disabled={isLoading}
              type="button"
              onClick={handleDownloadPDF}
              className="px-4 py-2 btn btn-outline rounded btn-sm btn-success"
            >
              {isLoading ? "Đang xử lý ..." : "Xuất PDF"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPDFModal;
